import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {
  DictService,
  TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION,
  TERMINALS_IMPORT_ROW_STATUS_UNSETTLED
} from "../../../../shared/services/dict.service";
import {takeUntil} from "rxjs/operators";
import {TerminalsImportRowService} from "../../../../shared/services/terminals-import-row.service";
import {TerminalsImportRow} from "../../../../shared/interface/terminals-import-row";
import {
  ChangePartnerFacilityDialogComponent
} from "../change-partner-facility-dialog/change-partner-facility-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {
  ConfirmDialogWithReasonComponent
} from "../../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";

@Component({
  selector: 'app-terminals-imports-row-details-view',
  templateUrl: './terminals-imports-row-details-view.component.html',
  styleUrls: ['./terminals-imports-row-details-view.component.scss']
})
export class TerminalsImportsRowDetailsViewComponent implements OnInit, OnDestroy {
  @Input() terminalsImportRow: Observable<TerminalsImportRow>;
  @Output() modifyClicked = new EventEmitter<any>();


  readonly TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION = TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION;
  readonly TERMINALS_IMPORT_ROW_STATUS_UNSETTLED = TERMINALS_IMPORT_ROW_STATUS_UNSETTLED;

  userPermissions: ReplaySubject<UserPermissions>;
  terminalsImportRowObject?: TerminalsImportRow;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private terminalsImportRowService: TerminalsImportRowService,
    private snack: MatSnackBar,
    private router: Router,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.terminalsImportRow
      .pipe(takeUntil(this.destroyed$))
      .subscribe((terminalsImportRow: TerminalsImportRow) => {
        this.terminalsImportRowObject = terminalsImportRow;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  partnerFacilityChange(): void {
    const dialogRef = this.dialog.open(ChangePartnerFacilityDialogComponent, {
      width: '700px',
      data: {
        terminalsObject: this.terminalsImportRowObject
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.modifyClicked.emit();
    });
  }

  statusChange(): void {
    const dialogRef = this.dialog.open(ConfirmDialogWithReasonComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zmienić status transakcji na  \'Rozliczona\'?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.reason) {
        this.terminalsImportRowService.statusChange(this.terminalsImportRowObject.uuid ,  result.reason)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              this.modifyClicked.emit();
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }
}
